import React, { useState, useEffect } from 'react';
import "./ProfileMain.css";
import { Avatar } from "@material-ui/core";
import { auth, db, storage } from "../firebase";
import firebase from "firebase";
import Dialog from "@material-ui/core/Dialog";
import { useHistory } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import Post from "../components/Post";
import PostBox from "../components/PostBox";

function ProfileMain({ username, uid }) {
    const [open, setOpen] = useState(false);
    // eslint-disable-next-line
    const [scroll, setScroll] = React.useState("paper");
    const [imageURL, setImageURL] = useState("");
    const [progress, setProgress] = useState(0);
    const [profileOwner, setProfileOwner] = useState();
    const [posts, setPosts] = useState([]);
    const [status, setStatus] = useState("");
    const [open2, setOpen2] = useState(false);
    const [scroll2, setScroll2] = React.useState("paper");
    const [open3, setOpen3] = useState(false);
    const [scroll3, setScroll3] = React.useState("paper");
    const [open4, setOpen4] = useState(false);
    const [scroll4, setScroll4] = React.useState("paper");
    const [open5, setOpen5] = useState(false);
    const [scroll5, setScroll5] = React.useState("paper");
    const [about, setAbout] = useState("");
    const [following, setFollowing] = useState(false);
    const [followers, setFollowers] = useState([]);
    const [cover, setCover] = useState(null);
    const [coverProgress, setCoverProgress] = useState(0);
    const [profileViewer, setProfileViewer] = useState();
    const [profileCreationDate, setProfileCreationDate] = useState("")
    const user = firebase.auth().currentUser;
    const history = useHistory("");

    useEffect(() => {
        db.collection("userInfo").doc(uid).onSnapshot((doc) => {
            setProfileOwner(doc.data())
        })
    }, [uid])

    useEffect(() => {
        db.collection("userInfo").doc(user?.uid).onSnapshot((userData) => {
            setProfileViewer(userData.data());
        })
    }, [user?.uid])

    if (profileOwner !== undefined) {
        if(profileOwner?.uid !== user?.uid) {
            document.getElementsByClassName("profile_picture_uploader")[0].disabled = true;
            document.getElementsByClassName("MuiAvatar-root")[0].style.cursor = "context-menu";
            document.getElementsByClassName("profileOwnerButton")[0].style.display = "none";
            document.getElementsByClassName("coverImagePicker")[0].disabled = true;
        }
    }

    const openAboutEditor = (scrollType3) => () => {
        setOpen3(true);
        setScroll3(scrollType3);
    }

    const closeAboutEditor = () => {
        setOpen3(false);
    }

    const descriptionElementRef3 = React.useRef(null);
        React.useEffect(() => {
            if (open) {
                const { current: descriptionElement } = descriptionElementRef3;
                if (descriptionElement !== null) {
                    descriptionElement.focus();
                }
            }
        }, [open3])

        const openPhotoSelector = () => {
            document.getElementsByClassName("profile_picture_uploader")[0].click();
        }
    
        const handleChange = (e) => {
            if (e.target.files[0]) {
                setImageURL(e.target.files[0])
            }
        }
    
        const openDeleteConfirmationDialogBox = (scrollType2) => () => {
            setOpen2(true);
            setScroll2(scrollType2)
        }
    
        const closeDeleteProfileConfirmationBox = () => {
            setOpen2(false)
        }

        const descriptionElementRef2 = React.useRef(null);
        React.useEffect(() => {
            if (open2) {
                const { current: descriptionElement } = descriptionElementRef2;
                if (descriptionElement !== null) {
                    descriptionElement.focus();
                }
            }
        }, [open2])

        const descriptionElementRef = React.useRef(null);
        React.useEffect(() => {
            if (open) {
                const { current: descriptionElement } = descriptionElementRef;
                if (descriptionElement !== null) {
                    descriptionElement.focus();
                }
            }
        }, [open])

        useEffect(() => {
            if (imageURL !== "") {
                setOpen(true);
            }
        }, [imageURL]);

        const BoxCloser = () => {
            setOpen(false);
            setImageURL("");
        }

        const handleUpload = (e) => {
            document.getElementsByClassName("progressBar")[0].style.display = "block";
            e.preventDefault();
            const uploadTask = storage.ref(`UserProfilePictures/${user.uid}`).put(imageURL);
            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                    setProgress(progress)
                },
                (error) => {
                    alert(error.message)
                },
                () => {
                    storage
                    .ref("UserProfilePictures")
                    .child(user.uid)
                    .getDownloadURL()
                    .then(url => {
                        user.updateProfile({ 
                            photoURL: url 
                        }).then(function () {
                            db.collection("userInfo").doc(user.uid).update({
                                photoURL: url
                            }).then(function () {
                                BoxCloser();
                                setProgress(0);
                        })
                        })
                    })
                }
            )
        }

        const changeCover = (e) => {
            document.getElementsByClassName("progressForCover")[0].style.display = "block";
            e.preventDefault();
            const uploadTask2 = storage.ref(`UserCoverPictures/${user.uid}`).put(cover);
            uploadTask2.on(
                "state_changed",
                (snapshot2) => {
                    const progressValueForCover = Math.round((snapshot2.bytesTransferred / snapshot2.totalBytes) * 100);
                    setCoverProgress(progressValueForCover)
                },
                (error2) => {
                    alert(error2.message)
                },
                () => {
                    storage
                    .ref("UserCoverPictures")
                    .child(user.uid)
                    .getDownloadURL()
                    .then(coverURL => {
                        db.collection("userInfo").doc(user.uid).update({
                            coverImage: coverURL
                        }).then(function () {
                            closeCoverDialog();
                            setCoverProgress(0);
                        })
                    })
                }
            )
        }
    
        const deleteProfile = (e) => {
            e.preventDefault();
            db.collection("userInfo").doc(user.uid).delete().then(function () {
                user.delete().then(function () {
                    history.push("/")
                })
            }).then(function () {
                alert("Your account has been succesfully deleted from TiTaniht but your posts (if you have posted something) and comments (if you have commented on a post) are still visible.")
            })
        }

        const submitAbout = (e) => {
            e.preventDefault();
            if (about.length === 0) {
                alert("Please type something to ave your about.")
                closeAboutEditor();
            } else {
                db.collection("userInfo").doc(user?.uid).update({
                    about
                }).then(function () {
                    closeAboutEditor();
                })
            }
        }

        const openStatusEditor = (scrollType4) => () => {
            setOpen4(true);
            setScroll4(scrollType4)
        }

        const descriptionElementRef4 = React.useRef(null);
        React.useEffect(() => {
            if (open4) {
                const { current: descriptionElement } = descriptionElementRef4;
                if (descriptionElement !== null) {
                    descriptionElement.focus();
                }
            }
        }, [open4])

        const closeStatusEditor = () => {
            setOpen4(false);
        }

        const updateStatus = (e) => {
            setStatus(e.target.value)
                if (500 - e.target.value < 0 || e.target.value.length === 0) {
                    document.getElementsByClassName("statusEditor__button")[0].style.display = "none";
                } else {
                    document.getElementsByClassName("statusEditor__button")[0].style.display= "block";
                }
        }

        const submitStatusMesssage = () => {
        if (500 - status.length < 0 || status.length === 0) {
            return;
        } else {
            db.collection("userInfo").doc(user?.uid).update({
                status
            }).then(
                closeStatusEditor()
            )
        }
    }

    useEffect(() => {
        db.collection("posts").orderBy("timestamp", "desc").onSnapshot(snapshot => {
            setPosts(snapshot.docs.map(doc => ({
                id: doc.id,
                post: doc.data(),
            })))
        })
    }, [])

    const removeAbout = (e) => {
        e.preventDefault();
        db.collection("userInfo").doc(user?.uid).update({
            about: ""
        }).then(function() {
            alert("Your about has successfully got removed")
        })
    }

    const followUser = (e) => {
        e.preventDefault();
        db.collection("userInfo").doc(profileOwner?.uid).collection("followers").doc(user?.uid).set({
            username: user?.displayName,
            photoURL: user?.photoURL,
            uid: user?.uid
        }).then(function () {
            db.collection("userInfo").doc(profileOwner?.uid).update({
                followers: profileOwner?.followers + 1
            }).then(function () {
                db.collection("userInfo").doc(user?.uid).collection("following").doc(profileOwner?.uid).set({
                    photoURL: profileOwner?.photoURL,
                    username: profileOwner?.displayName,
                    uid: profileOwner?.uid
                }).then(function () {
                    db.collection("userInfo").doc(user?.uid).update({
                        followings: profileViewer?.followings + 1
                    })
                })
            })
        })
    }

    const unFollowUser = (e) => {
        e.preventDefault();
        db.collection("userInfo").doc(profileOwner?.uid).collection("followers").doc(user?.uid).delete().then(function () {
            db.collection("userInfo").doc(profileOwner?.uid).update({
                followers: profileOwner?.followers - 1
            }).then(function () {
                db.collection("userInfo").doc(user?.uid).collection("followings").doc(profileOwner?.uid).delete();
            }).then(function () {
                db.collection("userInfo").doc(user?.uid).update({
                    followings: profileViewer?.followings - 1
                }).then(function () {
                    window.location.reload(true);
                })
            })
        });
    }

    useEffect(() => {
        db.collection("userInfo").doc(profileOwner?.uid).collection("followers").onSnapshot(snapy => {
            setFollowers(snapy.docs.map((docy) => {
                if (docy.id === user?.uid) {
                    setFollowing(true);
                }
            }))
        })
    }, [user?.uid, profileOwner?.uid])

    const chooseCover = () => {
        document.getElementsByClassName("coverImagePicker")[0].click();
    }

    useEffect(() => {
        if (cover !== null) {
            setOpen5(true)
        }
    }, [cover])

    const closeCoverDialog = () => {
        setOpen5(false);
    }

    const descriptionElementRef5 = React.useRef(null);
    React.useEffect(() => {
        if (open5) {
            const { current: descriptionElement } = descriptionElementRef5;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open5])

    const handleCoverChange = (e) => {
        if (e.target.files[0]) {
            setCover(e.target.files[0]);
        }
    }

    return (
        <div className="profileMain">
            <Dialog open={open} scroll={scroll} onClose={BoxCloser}>
                <div className="warningBox">
                <div className="warningText">
                <h4>Once you change your profile picture, you cannot change it back to the default one.</h4>
                <progress className="progressBar" value={progress} max="100" />
                </div>
                <div className="warningProceedButton">
                    <p onClick={handleUpload}>Yes, Proceed</p>
                    <p onClick={BoxCloser}>No, leave it</p>
                </div>
                </div>
            </Dialog>
            <Dialog open={open2} scroll={scroll2} onClose={closeDeleteProfileConfirmationBox}>
                <div className="profileDeleteConfirm">
                    <h4>Confirm</h4>
                    <p>Do you really want to delete your account. You cannot recover your account again and all your post will be present in Titaniht.</p>
                    <div className="deleteConfirmationButtons">
                        <button onClick={deleteProfile} className="deleteConfirmed">Delete my account</button>
                        <button onClick={closeDeleteProfileConfirmationBox} className="dontdeletebutton">Don't delete my account</button>
                    </div>
                </div>
            </Dialog>
            <Dialog open={open3} scroll={scroll3} onClose={closeAboutEditor}>
                <div className="about__editor">
                    <div className="about_editor_header">
                        <h2>Change your About</h2>
                        <CloseIcon onClick={closeAboutEditor}/>
                    </div>
                    <div className="about_editor_textarea">
                        <textarea placeholder={`Describe yourseft to the world, ${user?.displayName}`} value={about} onChange={(e) => setAbout(e.target.value)}/>
                    </div>
                    <div className="prv40f">
                        <button className="about__saveButton1" onClick={submitAbout}>Save</button>
                        <button onClick={closeAboutEditor}>Cancel</button>
                    </div>
                </div>
            </Dialog>
            <Dialog open={open4} onClose={closeStatusEditor} scroll={scroll4}>
                <div className="status__editor">
                    <div className="statusEditor__header">
                        <h2>Edit Status</h2>
                        <CloseIcon onClick={closeStatusEditor}/>
                    </div>
                    <div className="statusEditor__input">
                        <textarea placeholder="Type your status message here..." value={status} onChange={updateStatus}/>
                        <p style={{ marginLeft: "10px" }}>{`You can only input ${500 - status.length} characters`}</p>
                    </div>
                    <div className="statusEditor__button">
                        <button onClick={submitStatusMesssage}>Save changes</button>
                    </div>
                </div>
            </Dialog>
            <Dialog open={open5} scroll={scroll5} onClose={closeCoverDialog}>
                <div className="changeCover">
                    <div className="changeCover__confirmMessage">
                        <h3>Confirm that you want to change your cover picture. You can always change it anytime.</h3>
                    </div>
                    <progress className="progressForCover" max="100" value={coverProgress} />
                    <div className="changeCover__buttons">
                        <p onClick={changeCover}>Yes, proceed</p>
                        <p onClick={closeCoverDialog}>Leave</p>
                    </div>
                </div>
            </Dialog>
            <div className="profileMain__basicUserInfo">
                <div className="coverImage">
                    {
                        profileOwner?.coverImage === "" ? (
                            <img src="/Images/Default-coverImage-bluefil__cover.jpeg" alt="" onClick={chooseCover} />
                        ) : (
                            <img src={profileOwner?.coverImage} alt="" onClick={chooseCover} />
                        )
                    }
                    <input type="file" className="coverImagePicker" accept="image/*" onChange={handleCoverChange}/>
                </div>
                <div className="textInfoAndProfilePicture">
                    <div className="profileDownLeftInfo">
                        <Avatar src={profileOwner?.photoURL} onClick={openPhotoSelector}/>
                        <input type="file" className="profile_picture_uploader" onChange={handleChange} accept="image/*"/>
                        <div className="nameAndFollowersAndFollowing">
                            <h2>{username}</h2>
                            <div className="followersAndFollowing">
                                <p>{`${profileOwner?.followers} ${profileOwner?.followers === 1 ? "follower" : "followers"}`}</p>
                                <p style={{ marginLeft: "8px" }}>{`${profileOwner?.followings} following`}</p>
                            </div>
                            <div className="profile__creationDate">
                                <p><strong>Profile created on:</strong> {profileOwner?.creationTime}</p>
                            </div>
                        </div>
                    </div>
                    <div className="profileOwnerButton">
                            <p onClick={openStatusEditor("body")}>Edit status message</p>
                            <div className="deleteProfileAndEditAboutButtons">
                                <p className="deleteProfile" onClick={openDeleteConfirmationDialogBox("body")}>Delete Profile</p>
                                <p className="about_editoropening_button" onClick={openAboutEditor("body")}>Edit About</p>
                            </div>
                        </div>
                </div>
                <div className="profileBasicInfoBottomPart">
                    <div className="profile__statusText">
                        <p style={{ fontWeight: "bold" }}>{profileOwner?.status}</p>
                    </div>

                    {
                        profileOwner?.uid !== user?.uid ?  (
                            <div className="followButton">
                                {
                                    user && (
                                        <>
                                        {
                                            following === false ? (
                                                <div className="followButton">
                                                    <button className="follow__button" onClick={followUser}>Follow</button>
                                                </div>
                                            ) : (
                                                <div className="unFollowButton">
                                                    <button className="unfollow__button" onClick={unFollowUser}>Unfollow</button>
                                                </div>
                                            )
                                        }
                                        </>
                                    )
                                }
                            </div>
                        ) : (
                            null
                        )
                    }
                </div>
            </div>
            <div className="porfile__body">
                <br />
                <div className="profile_body_rightSide">
                {
                    profileOwner?.about && (
                            <div className="about">
                        <div className="about__header">
                            <h1>About</h1>
                            {
                                profileOwner?.uid === user?.uid && (
                                    <p className="about_remove_p" onClick={removeAbout}>Remove About</p>
                                )
                            }
                        </div>
                        <div className="about__text">
                            <p>{profileOwner?.about}</p>
                        </div>
                    </div>
                    )
                }
                <div className="posts">
                    {
                        uid === user?.uid && (
                            <PostBox username={username} uid={uid} />
                        )
                    }
                    <br />
                    {
                        posts.map(({id, post}) => (
                            post.uid !== uid ? (
                                console.log()
                            ) : (
                                <Post key={id} postId={id} user={user} username={post.username} caption={post.caption} imageUrl={post.imageUrl} photoURL={post.photoURL} likes={post.likes} timestamp={post.timestamp} uid={post.uid} />
                            )
                    ))
                    }
                </div>
                </div>
                </div>
        </div>
    )
}

export default ProfileMain;